import moment from 'moment';
import React from 'react';

import { DateMainProps } from './localGeneric';
import {
  Container,
  DateContainer,
  DateInput,
  DateQuestionTitle,
} from './styles';

export const format = (dateString: string): string => {
  const intParsed = parseInt(dateString, 10);
  if (!intParsed) return '';
  const parsed = new Date(intParsed * 1000);

  if (parsed) {
    return moment(parsed, 'YYYY-MM-DD').format('YYYY-MM-DD');
  }
  return '';
};

const Dates: React.FC<DateMainProps> = (props) => {
  const { name, value, max, min, onChange } = props;
  const parsedValue = format(value);
  const parsedMin = format(min || '0');

  return (
    <Container>
      <DateQuestionTitle>{name}</DateQuestionTitle>
      <DateContainer>
        <DateInput
          type="date"
          min={parsedMin}
          max={max}
          value={parsedValue}
          onChange={(e) => onChange(e.target.value)}
          placeholder="DD/MM/AAAA"
        />
      </DateContainer>
    </Container>
  );
};

export default Dates;
